import { render, staticRenderFns } from "./ReviewVideo.vue?vue&type=template&id=125b80ea&scoped=true"
import script from "./ReviewVideo.vue?vue&type=script&lang=js"
export * from "./ReviewVideo.vue?vue&type=script&lang=js"
import style0 from "./ReviewVideo.vue?vue&type=style&index=0&id=125b80ea&prod&lang=scss&scoped=true"
import style1 from "./ReviewVideo.vue?vue&type=style&index=1&id=125b80ea&prod&lang=scss"
import style2 from "./ReviewVideo.vue?vue&type=style&index=2&id=125b80ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b80ea",
  null
  
)

export default component.exports